<template>
    <div>
    <h3 class="is-size-3">Obtener indicadores</h3>
        <p> <code>GET {{ host }}/api/indicators/{date?}</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint tiene un parametro opcional:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>date</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato de fecha aceptado YYYY-MM-DD (Ej. 2020-01-13)</li>
                        <li>Valor por default: Hoy</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5>
        <pre>
        <code>headers:
        {
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>{
            "exchangeDate":"2020-01-13",
            "USD": "18.8453",
            "EURO": "20.8242",
            "udis": "6.413049",
            "inflationAnnual": "3.24000000"
        }</code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>